import { render, staticRenderFns } from "./MailText.vue?vue&type=template&id=2c0c024c&scoped=true&"
var script = {}
import style0 from "./MailText.vue?vue&type=style&index=0&id=2c0c024c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c024c",
  null
  
)

export default component.exports